import { render, staticRenderFns } from "./registration-fields.vue?vue&type=template&id=23958e77&scoped=true"
import script from "./registration-fields.vue?vue&type=script&lang=js"
export * from "./registration-fields.vue?vue&type=script&lang=js"
import style0 from "./registration-fields.vue?vue&type=style&index=0&id=23958e77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23958e77",
  null
  
)

export default component.exports